export default class GoToTop {
    constructor(lenis) {
        this.lenis = lenis;
        this.button = document.querySelector(".no-go-to-top");
        this.progressCircle = document.querySelector(
            ".no-go-to-top__circle-progress"
        );
        this.circumference = 163.36; // 2 * PI * 26 (radius)
        this.showThreshold = 300; // Show button after scrolling 300px

        if (!this.button || !this.progressCircle) {
            console.warn("[GoToTop] Button or progress circle not found");
            return;
        }

        this.init();
    }

    init() {
        console.log("[GoToTop] init()");
        this.bindEvents();
        this.updateProgress();
    }

    bindEvents() {
        // Click event
        this.button.addEventListener("click", () => this.scrollToTop());

        // Scroll event (using requestAnimationFrame for better performance)
        if (this.lenis) {
            this.lenis.on("scroll", () => {
                this.updateProgress();
            });
        } else {
            // Fallback for no Lenis
            let ticking = false;
            window.addEventListener("scroll", () => {
                if (!ticking) {
                    window.requestAnimationFrame(() => {
                        this.updateProgress();
                        ticking = false;
                    });
                    ticking = true;
                }
            });
        }
    }

    updateProgress() {
        const scrollTop =
            window.pageYOffset || document.documentElement.scrollTop;
        const docHeight =
            document.documentElement.scrollHeight - window.innerHeight;
        const scrollPercent = (scrollTop / docHeight) * 100;

        // Update circle progress
        const offset =
            this.circumference - (scrollPercent / 100) * this.circumference;
        this.progressCircle.style.strokeDashoffset = offset;

        // Show/hide button
        if (scrollTop > this.showThreshold) {
            this.button.classList.add("is-visible");
        } else {
            this.button.classList.remove("is-visible");
        }
    }

    scrollToTop() {
        if (this.lenis) {
            this.lenis.scrollTo(0, {
                duration: 1.5,
                easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            });
        } else {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }
    }
}
